import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const batchUploadJt808ParameterData = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/batchuploadjt808parameterdata' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const uploadJt808ParameterDataFile = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/uploadjt808parameterdatafile' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchUploadJt808ParameterDataFile = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808parameterdata/batchuploadjt808parameterdatafile' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}
